export default "__VITE_ASSET__eeXh07hJ__"